export interface CreatePersonaInquiryRequest {
  referenceId?: string
  firstName?: string
  lastName?: string
  email?: string
  phoneNumber?: string
  birthdate?: string
  language?: string
}

export interface PersonaInquiryResponse {
  inquiryId: string
  hostedFlowUrl: string
  status: string
  referenceId: string
}

export enum PersonaInquiryStatusEnum {
  PENDING = 'pending',
  STARTED = 'started',
  COMPLETED = 'completed',
  APPROVED = 'approved',
  DECLINED = 'declined',
  FAILED = 'failed',
  EXPIRED = 'expired',
  EMPTY = '',
}

export interface ResumePersonaInquiryRequest {
  userId: string
}

export interface ResumePersonaInquiryResponse {
  inquiryId: string
  status: string
  hostedFlowUrl: string
  sessionToken: string
}
